<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill">
        <dx-data-grid
            #dataGrid
            [dataSource]="employees"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
        >
            <dxi-column dataField="firstName" width="150"></dxi-column>
            <dxi-column dataField="lastName" width="150"></dxi-column>
            <dxi-column dataField="displayAddress" caption="Address" width="250"></dxi-column>
            <dxi-column dataField="cellPhone"></dxi-column>
            <dxi-column dataField="email" width="200"></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="employee-search-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button type="button" (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)" class="btn btn-success">Open</button>
                <button type="button" (click)="open()" class="btn btn-secondary ml-2">New</button>
                <button type="button" (click)="toggleShowActive()" class="btn btn-sm btn-warning ml-3">{{ showActive ? 'Show All' : 'Show Active' }}</button>
            </div>

            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="employees" class="mr-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
